import {memo} from "react";
import {Bar, Column} from '@ant-design/charts';

const SkillsBarChart = memo(({data, xAxis = 'source', yAxis = 'target', customConfig = {}}) => {

    // note: this is now bar chart, just inverted something to flip column chart to bar
    // note 2: this component used to be Column chart.

    let sortedData = [...data];
    sortedData.sort((a, b) => a.amount - b.amount )
    sortedData.reverse()

    let config = {
        data: sortedData,
        xField: yAxis,
        yField: xAxis,
        xAxis: {
            label: {
                autoHide: true,
                autoRotate: false,
            },
        },
        scrollbar: {
            type: 'vertical'
        },
    };

    return (
        <Bar {...config} {...customConfig} />
    )
})

export default SkillsBarChart;